import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const COLORS = ['#3b82f6', '#8b5cf6', '#10b981', '#f59e0b', '#ef4444', '#6366f1'];

const LeadSourceAttribution = ({ data }) => {
  const sourceData = (data?.sourceBreakdown || [])?.map((item, index) => ({
    name: item?.source?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c?.toUpperCase()),
    value: item?.count,
    color: COLORS?.[index % COLORS?.length]
  }));

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <h3 className="text-lg font-semibold text-foreground mb-6">Lead Source Attribution</h3>
      {sourceData?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="PieChart" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <p className="text-muted-foreground">No source data available yet</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={sourceData} cx="50%" cy="50%" outerRadius={100} dataKey="value" label={({ name, percent }) => `${name} ${(percent * 100)?.toFixed(0)}%`}>
                {sourceData?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry?.color} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => [value, 'Leads']} />
            </PieChart>
          </ResponsiveContainer>
          <div className="space-y-3">
            {sourceData?.map((item, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item?.color }} />
                  <span className="text-sm font-medium text-foreground">{item?.name}</span>
                </div>
                <span className="text-sm font-bold text-foreground">{item?.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadSourceAttribution;